import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {CountdownModule} from 'ngx-countdown';

import {AcMenuCountdownComponent} from './ac-menu-countdown/ac-menu-countdown.component';
import {AcMenuOptionsComponent} from './ac-menu-options/ac-menu-options.component';
import {AcMenuUserInfoComponent} from './ac-menu-user-info/ac-menu-user-info.component';
import {AcIconsModule} from '../ac-icons/ac-icons.module';
import {InfraDirectivesModule} from '../../directives/infra.directives.module';
import {InfraPipesModule} from '../../pipes/infra.pipes.module';
import {AcInputContainerModule} from '../ac-input-container/ac-input-container.module';
import {AcSingleSelectModule} from '../ac-single-select/ac-single-select.module';

@NgModule({
    imports: [
        CommonModule,
        AcIconsModule,
        CountdownModule,
        InfraDirectivesModule,
        InfraPipesModule,
        AcInputContainerModule,
        AcSingleSelectModule
    ],
    declarations: [
        AcMenuUserInfoComponent,
        AcMenuOptionsComponent,
        AcMenuCountdownComponent
    ],
    exports: [
        AcMenuUserInfoComponent,
        AcMenuOptionsComponent,
        AcMenuCountdownComponent
    ]
})
export class AcMenuModule {
}
